import { render, staticRenderFns } from "./RequestedClasses.vue?vue&type=template&id=4825b0c9&scoped=true&"
import script from "./RequestedClasses.vue?vue&type=script&lang=js&"
export * from "./RequestedClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4825b0c9",
  null
  
)

export default component.exports